module.exports = __webpack_public_path__ + "img/payment-success.9567f896.svg";